module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'medIdInput') ? _c('MedIdInput', {
    attrs: {
      "inputLabel": '輸入病歷號'
    },
    on: {
      "setText": _vm.getMedId
    }
  }) : _vm._e(), (_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "actionProgress": _vm.actionProgress,
      "confirmProgress": _vm.confirmProgress,
      "medRecordId": _vm.medRecordId
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1032b1c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FetchDrugGroupFlow/MultiFlow.vue
// module id = 1387
// module chunks = 1